export default function Hero() {
  return (
    <section className="relative -mt-16 w-full overflow-hidden md:-mt-20" aria-label="Nova coleção Amora Belle">
      <div className="absolute inset-0 h-full w-full">
        <div className="ab-float h-full w-full">
          <img
            src="https://readdy.ai/api/search-image?query=Editorial%20fashion%20photography%20of%20a%20confident%20Brazilian%20woman%20with%20natural%20curly%20hair%20wearing%20an%20elegant%20contemporary%20feminine%20outfit%20in%20deep%20plum%20and%20cream%20tones%2C%20standing%20in%20a%20warm%20sunlit%20urban%20Brazilian%20setting%20with%20soft%20neutral%20walls%2C%20natural%20daylight%2C%20realistic%20skin%20texture%2C%20warm%20welcoming%20mood&width=1600&height=1000&seq=amora-hero-main-01&orientation=landscape"
            alt="Mulher brasileira usando look contemporâneo da nova coleção Amora Belle"
            title="Nova coleção Amora Belle — moda feminina contemporânea"
            className="h-full w-full object-cover object-top"
          />
        </div>
        <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/55 via-foreground-950/40 to-foreground-950/65" />
      </div>

      <div className="relative z-10 flex min-h-[640px] w-full items-center px-4 pb-16 pt-28 md:h-[740px] md:px-8 md:pb-20 md:pt-32">
        <div className="mx-auto w-full max-w-6xl">
          <div className="ab-fade-in max-w-xl text-left">
            <span className="inline-flex items-center gap-2 rounded-full border border-background-50/40 bg-background-50/10 px-4 py-1.5 text-[11px] uppercase tracking-[0.24em] text-background-50 backdrop-blur-sm">
              <span className="flex h-3 w-3 items-center justify-center">
                <i className="ri-leaf-line text-[11px] text-secondary-300" />
              </span>
              Nova coleção Amora Belle
            </span>

            <h1 className="mt-6 font-heading text-4xl font-medium leading-[1.1] text-background-50 md:text-6xl">
              Moda para viver cada versão de você
            </h1>

            <p className="mt-5 max-w-lg text-sm leading-relaxed text-background-100 md:text-base">
              Peças que acompanham sua rotina, valorizam seu estilo e fazem você se sentir bem em todos os momentos.
            </p>

            <div className="mt-8 flex flex-col gap-3 sm:flex-row sm:items-center">
              <a
                href="#novidades"
                className="inline-flex cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-7 py-3.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
              >
                Ver novidades
                <i className="ri-arrow-right-line text-base" />
              </a>
              <a
                href="#looks"
                className="inline-flex cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-50/60 px-7 py-3.5 text-sm font-medium text-background-50 transition-colors hover:bg-background-50/15"
              >
                Conhecer as coleções
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}